import { LotacaoAndEstagioSelectFieldModel } from 'components/form/field/select/LotacaoAndEstagioSelectField/LotacaoAndEstagioSelectField'
import { ObrigatoriedadeParticipacaoSigtapDto } from 'graphql/types.generated'

import { ManterCidadaoLista } from './components/DesfechoAtendimentoPanel'
import { ProcedimentoSigtapFieldModel } from './components/ProcedimentoSigtapField'

export interface ObrigatoriedadesParticipacao {
  isParticipacaoCidadao: boolean
  isParticipacaoProfissional: boolean
  isParticipacaoAmbos: boolean
}

export interface DescricaoProcedimentosTeleconsulta {
  descricaoProcedimentosCidadaoEAmbos: string[]
  descricaoProcedimentosProfissionalEAmbos: string[]
}

export interface isCondutaRequiredProps {
  isObservacao: boolean
  hasNotificacaoCasoSuspeito: boolean
  hasEncaminhamentoExterno: boolean
  manterCidadaoNaLista: ManterCidadaoLista
}

export const isCondutaRequired = (props: isCondutaRequiredProps) => {
  const { isObservacao, hasEncaminhamentoExterno, hasNotificacaoCasoSuspeito, manterCidadaoNaLista } = props

  const isObservacaoMantendoNaLista = isObservacao && manterCidadaoNaLista === ManterCidadaoLista.SIM
  const hasEncaminhamentoOuNotificacao = hasNotificacaoCasoSuspeito || hasEncaminhamentoExterno

  return !(hasEncaminhamentoOuNotificacao || isObservacaoMantendoNaLista)
}

export const obrigatoriedadesParticipacaoTeleconsulta = (
  regrasObrigatoriedadeParticipacao: ObrigatoriedadeParticipacaoSigtapDto,
  procedimentosTeleconsulta: ProcedimentoSigtapFieldModel[],
  lotacaoAtendCompartilhado: LotacaoAndEstagioSelectFieldModel | undefined,
  isProfissionalNaoListado: boolean
) => {
  const descricoesCidadao: string[] = []
  const descricoesProfissional: string[] = []
  const descricoesAmbos: string[] = []

  const {
    sigtapsCidadaoObrigatorio,
    sigtapsProfissionalObrigatorio,
    sigtapsCidadaoEProfissionalObrigatorios,
  } = regrasObrigatoriedadeParticipacao

  procedimentosTeleconsulta.forEach(({ procedimento }) => {
    const codigo = procedimento?.codigo

    if (!codigo) return

    const descricao = procedimento.descricao

    if (sigtapsCidadaoObrigatorio.includes(codigo)) {
      descricoesCidadao.push(descricao)
    }
    if (sigtapsProfissionalObrigatorio.includes(codigo)) {
      descricoesProfissional.push(descricao)
    }
    if (sigtapsCidadaoEProfissionalObrigatorios.includes(codigo)) {
      descricoesAmbos.push(descricao)
    }
  })

  const isPartiCidadao = descricoesCidadao.length > 0
  const isPartiProfissional = descricoesProfissional.length > 0
  const isPartiAmbos = descricoesAmbos.length > 0
  return {
    obrigatoriedades: {
      isParticipacaoCidadao: isPartiCidadao,
      isParticipacaoProfissional:
        isPartiProfissional || lotacaoAtendCompartilhado?.id != null || isProfissionalNaoListado,
      isParticipacaoAmbos: isPartiAmbos,
    },
    descricoes: {
      descricaoProcedimentosCidadaoEAmbos: [...descricoesCidadao, ...descricoesAmbos],
      descricaoProcedimentosProfissionalEAmbos: [...descricoesProfissional, ...descricoesAmbos],
    },
  }
}
